import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../lib/supabase';

// Shows a morning dream journal reminder between 06:00 and 11:00
// and only when the user hasn't visited the dream journal today.
export function DreamJournalPrompt() {
  const navigate = useNavigate();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const hour = new Date().getHours();
    if (hour < 6 || hour >= 11) return; // Only morning window

    (async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) return;

      // Check if used dream journal today
      const today = new Date().toISOString().slice(0, 10);
      const { data } = await supabase
        .from('system_usage')
        .select('last_used')
        .eq('user_id', user.id)
        .eq('system_name', 'diario_sonhos')
        .maybeSingle();

      const lastUsed = data?.last_used?.slice(0, 10);
      if (lastUsed === today) return; // Already visited today

      // Check dismiss key
      const key = `dream_prompt_${today}`;
      if (localStorage.getItem(key)) return;

      setShow(true);
    })();
  }, []);

  function dismiss() {
    const key = `dream_prompt_${new Date().toISOString().slice(0, 10)}`;
    localStorage.setItem(key, '1');
    setShow(false);
  }

  if (!show) return null;

  return (
    <div className="border border-[#C9A84C]/30 rounded-sm p-4 bg-[#C9A84C]/5 flex items-start gap-3">
      <span className="text-2xl flex-shrink-0">💭</span>
      <div className="flex-1 min-w-0">
        <p className="text-[#F5ECD7]/90 text-sm font-medium mb-1">
          Você se lembra do seu sonho?
        </p>
        <p className="text-[#F5ECD7]/60 text-xs leading-relaxed mb-3">
          Registre agora antes que os detalhes se apaguem, interpretamos o significado astrológico para você.
        </p>
        <div className="flex gap-2">
          <button
            onClick={() => { dismiss(); navigate('/diario-sonhos'); }}
            className="px-4 py-2 bg-[#C9A84C] text-[#0D1130] text-xs font-bold uppercase tracking-wider hover:bg-[#C9A84C]/90 transition-colors"
          >
            Registrar sonho
          </button>
          <button
            onClick={dismiss}
            className="px-3 py-2 text-[#F5ECD7]/40 text-xs hover:text-[#F5ECD7]/70 transition-colors"
          >
            Agora não
          </button>
        </div>
      </div>
    </div>
  );
}
